module.exports = __webpack_public_path__ + "img/ELSA_logo.1f72ee7c.png";